// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntable.table thead td[data-v-610d50ac]:not(:nth-child(1)),\ntable.table tbody td[data-v-610d50ac]:not(:nth-child(1)),\ntable.table thead th[data-v-610d50ac]:not(:nth-child(1)),\ntable.table tbody th[data-v-610d50ac]:not(:nth-child(1)),\ntable.table thead td[data-v-610d50ac]:first-child,\ntable.table tbody td[data-v-610d50ac]:first-child,\ntable.table thead th[data-v-610d50ac]:first-child,\ntable.table tbody th[data-v-610d50ac]:first-child {\n  padding: 0 15px;\n}\n", ""]);
// Exports
module.exports = exports;
